/* LK — interaction layer.
   Quick view, compare tray, recently viewed and toasts. All storage is
   localStorage (per browser); nothing is written to the shop. */
(function () {
  'use strict';
  var W = window, LKUI = (W.LKUI = W.LKUI || {});
  /* Several sections include this file. Bind the delegated listeners once only -
     two copies meant every click toggled twice and cancelled itself out. */
  if (W.__LK_UI_BOUND) return;
  W.__LK_UI_BOUND = true;
  var reduced = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function read(k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function money(c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }

  /* ---------- toast ---------- */
  var tw;
  LKUI.toast = function (msg) {
    if (!tw) { tw = document.createElement('div'); tw.className = 'lk-toast-wrap'; document.body.appendChild(tw); }
    var t = document.createElement('div'); t.className = 'lk-toast'; t.textContent = msg; tw.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('on'); });
    setTimeout(function () { t.classList.remove('on'); setTimeout(function () { t.remove(); }, 300); }, 2200);
  };

  /* ---------- quick view ---------- */
  var qv, qvScrim, qvState = null;
  function buildQV() {
    if (qv) return;
    qvScrim = document.createElement('div'); qvScrim.className = 'lk-qv-scrim';
    qv = document.createElement('div'); qv.className = 'lk-qv'; qv.setAttribute('role', 'dialog'); qv.setAttribute('aria-modal', 'true'); qv.tabIndex = -1;
    document.body.appendChild(qvScrim); document.body.appendChild(qv);
    qvScrim.addEventListener('click', closeQV);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQV(); });
  }
  function closeQV() { if (!qv) return; qv.classList.remove('on'); qvScrim.classList.remove('on'); document.documentElement.style.overflow = ''; }

  LKUI.quickView = function (handle) {
    buildQV();
    qv.innerHTML = '<span class="lk-qv-bar"></span><p style="padding:30px 0;text-align:center;color:#6B6B6B">Loading…</p>';
    qv.classList.add('on'); qvScrim.classList.add('on'); document.documentElement.style.overflow = 'hidden';
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        qvState = { p: p, v: p.variants.find(function (v) { return v.available; }) || p.variants[0] };
        renderQV();
      })
      .catch(function () { qv.innerHTML = '<span class="lk-qv-bar"></span><p style="padding:30px 0;text-align:center">Could not load this frame. <a href="/products/' + handle + '">Open the page</a></p>'; });
  };
  function renderQV() {
    var p = qvState.p, v = qvState.v;
    var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
    var cmp = v.compare_at_price, pct = cmp && cmp > v.price ? Math.round((cmp - v.price) / cmp * 100) : 0;
    var ci = -1;
    p.options.forEach(function (o, i) { if (/colou?r/i.test(o.name || o)) ci = i; });
    var sw = '';
    if (ci > -1 && p.variants.length > 1) {
      sw = '<div class="lk-qv-sw">' + p.variants.slice(0, 8).map(function (x, i) {
        var im = x.featured_image && x.featured_image.src;
        return '<button type="button" data-qvv="' + i + '" class="' + (x.id === v.id ? 'on' : '') + '" title="' + (x.options[ci] || x.title) + '">' + (im ? '<img src="' + im + '" alt="">' : '') + '</button>';
      }).join('') + '</div>';
    }
    qv.innerHTML =
      '<span class="lk-qv-bar"></span><button class="lk-qv-close" type="button" aria-label="Close">&times;</button>' +
      '<div><div class="lk-qv-shot">' + (img ? '<img src="' + img + '" alt="' + p.title + '">' : '') + '</div></div>' +
      '<div><p class="lk-qv-meta">' + (p.type || '') + '</p><h3>' + p.title + '</h3>' +
      '<div class="lk-qv-price"><b>' + money(v.price) + '</b>' + (pct ? '<s>' + money(cmp) + '</s><em>' + pct + '% off</em>' : '') + '</div>' +
      sw +
      '<div class="lk-qv-actions">' +
      '<button class="lk-btn lk-btn-primary" type="button" data-qv-add>' + (v.available ? 'Add to bag' : 'Sold out') + '</button>' +
      '<a class="lk-btn lk-btn-light" href="/products/' + p.handle + '">Full details</a></div></div>';
    qv.querySelector('.lk-qv-close').addEventListener('click', closeQV);
    qv.querySelectorAll('[data-qvv]').forEach(function (b) {
      b.addEventListener('click', function () { qvState.v = qvState.p.variants[+b.getAttribute('data-qvv')]; renderQV(); });
    });
    var add = qv.querySelector('[data-qv-add]');
    if (!qvState.v.available) { add.disabled = true; return; }
    add.addEventListener('click', function () {
      add.disabled = true; add.textContent = 'Adding';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: qvState.v.id, quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { LKUI.toast('Added to bag'); closeQV(); bumpBag(); if (window.LKRX && LKRX.syncAttributes) LKRX.syncAttributes(); })
        .catch(function () { add.disabled = false; add.textContent = 'Try again'; });
    });
  }
  function bumpBag() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('.lk-count').forEach(function (b) { if (b.closest('a[href*="cart"]')) b.textContent = c.item_count; });
    }).catch(function () {});
  }

  /* ---------- recently viewed ---------- */
  LKUI.noteView = function (handle) {
    if (!handle) return;
    var l = read('lk_rv', []).filter(function (h) { return h !== handle; });
    l.unshift(handle); write('lk_rv', l.slice(0, 12));
  };
  LKUI.renderRecent = function (host) {
    var list = read('lk_rv', []).filter(function (h) { return h !== host.getAttribute('data-exclude'); });
    if (!list.length) { host.closest('[data-lk-rv-sec]') && (host.closest('[data-lk-rv-sec]').hidden = true); return; }
    Promise.all(list.slice(0, 10).map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      var html = ps.filter(Boolean).map(function (p) {
        var cmp = p.compare_at_price, pct = cmp && cmp > p.price ? Math.round((cmp - p.price) / cmp * 100) : 0;
        return '<article class="lk-card"><a class="lk-card-link" href="/products/' + p.handle + '">' +
          '<div class="lk-card-shot">' + (p.featured_image ? '<img src="' + p.featured_image + '" alt="" loading="lazy">' : '') + '</div>' +
          '<div class="lk-card-body"><span class="lk-card-title">' + p.title + '</span>' +
          '<span class="lk-card-price">' + money(p.price) + (pct ? ' <s>' + money(cmp) + '</s> <em>' + pct + '% off</em>' : '') + '</span>' +
          '</div></a></article>';
      }).join('');
      if (!html) { var s = host.closest('[data-lk-rv-sec]'); if (s) s.hidden = true; return; }
      host.innerHTML = html;
      var sec = host.closest('[data-lk-rv-sec]'); if (sec) sec.hidden = false;
    });
  };

  /* ---------- compare ---------- */
  var tray;
  function cmpList() { return read('lk_cmp', []); }
  LKUI.renderCompare = function () {
    var list = cmpList();
    document.querySelectorAll('[data-lk-cmp-add]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.getAttribute('data-lk-cmp-add')) !== -1 ? 'true' : 'false');
    });
    if (!tray) {
      tray = document.createElement('div'); tray.className = 'lk-cmp-tray';
      tray.innerHTML = '<div class="lk-cmp-items"></div><button class="lk-cmp-go" type="button">Compare</button>';
      document.body.appendChild(tray);
      tray.querySelector('.lk-cmp-go').addEventListener('click', openCompare);
    }
    var items = tray.querySelector('.lk-cmp-items');
    tray.classList.toggle('on', list.length > 0);
    tray.querySelector('.lk-cmp-go').disabled = list.length < 2;
    tray.querySelector('.lk-cmp-go').textContent = 'Compare (' + list.length + ')';
    Promise.all(list.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        items.innerHTML = ps.filter(Boolean).map(function (p) {
          return '<span class="lk-cmp-chip"><img src="' + (p.featured_image || '') + '" alt="' + p.title + '"><button type="button" data-cmp-rm="' + p.handle + '" aria-label="Remove">&times;</button></span>';
        }).join('');
      });
  };
  LKUI.toggleCompare = function (handle) {
    var l = cmpList(), i = l.indexOf(handle);
    if (i > -1) l.splice(i, 1);
    else { if (l.length >= 4) { LKUI.toast('Compare up to 4 frames'); return; } l.push(handle); }
    write('lk_cmp', l); LKUI.renderCompare();
  };
  function openCompare() {
    var list = cmpList(); if (list.length < 2) return;
    buildQV();
    qv.innerHTML = '<span class="lk-qv-bar"></span><p style="padding:30px;text-align:center;color:#6B6B6B">Loading…</p>';
    qv.classList.add('on'); qvScrim.classList.add('on'); document.documentElement.style.overflow = 'hidden';
    Promise.all(list.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.json(); }); })).then(function (ps) {
      function spec(p, re) { var m = (p.description || '').replace(/<[^>]+>/g, ' ').match(re); return m ? m[1] : '—'; }
      var rows = [
        ['', ps.map(function (p) { return '<img src="' + (p.featured_image || '') + '" alt="">'; })],
        ['Frame', ps.map(function (p) { return '<a href="/products/' + p.handle + '">' + p.title + '</a>'; })],
        ['Price', ps.map(function (p) { return money(p.price); })],
        ['Type', ps.map(function (p) { return p.type || '—'; })],
        ['Colours', ps.map(function (p) { return p.variants.length > 1 ? p.variants.length : '1'; })],
        ['Size', ps.map(function (p) { return spec(p, /(\d{2}\s*[-–□]\s*\d{2}\s*[-–]\s*\d{2,3})/); })]
      ];
      qv.innerHTML = '<span class="lk-qv-bar"></span><button class="lk-qv-close" type="button" aria-label="Close">&times;</button>' +
        '<div style="grid-column:1/-1"><h3 style="margin-bottom:10px">Compare frames</h3><div style="overflow-x:auto"><table class="lk-cmp-table"><tbody>' +
        rows.map(function (r) { return '<tr><th>' + r[0] + '</th>' + r[1].map(function (c) { return '<td>' + c + '</td>'; }).join('') + '</tr>'; }).join('') +
        '</tbody></table></div></div>';
      qv.querySelector('.lk-qv-close').addEventListener('click', closeQV);
    });
  }

  /* ---------- delegated ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-lk-qv]');
    if (q) { e.preventDefault(); LKUI.quickView(q.getAttribute('data-lk-qv')); return; }
    var c = e.target.closest('[data-lk-cmp-add]');
    if (c) { e.preventDefault(); LKUI.toggleCompare(c.getAttribute('data-lk-cmp-add')); return; }
    var rm = e.target.closest('[data-cmp-rm]');
    if (rm) { e.preventDefault(); LKUI.toggleCompare(rm.getAttribute('data-cmp-rm')); }
  });

  function boot() {
    var h = document.body.getAttribute('data-lk-product-handle');
    if (h) LKUI.noteView(h);
    document.querySelectorAll('[data-lk-recent]').forEach(LKUI.renderRecent);
    LKUI.renderCompare();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
